import React from 'react';
import '../../styles/Technology.css';
import { 
  Cloud, 
  WifiOff, 
  Database, 
  Shield,
  Server,
  Brain
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface Infrastructure {
  name: string;
  icon: React.ReactNode;
  description: string;
  category: string;
}

const Technology: React.FC = () => {
  const { t } = useLanguage();
  const infrastructure: Infrastructure[] = [
    {
      name: t('infrastructure.hardware.title'),
      icon: <Cloud className="w-10 h-10" />,
      description: t('infrastructure.hardware.description'),
      category: t('infrastructure.hardware.category')
    },
    {
      name: t('infrastructure.server.title'),
      icon: <Shield className="w-10 h-10" />,
      description: t('infrastructure.server.description'),
      category: t('infrastructure.server.category')
    },
    {
      name: t('infrastructure.communication.title'),
      icon: <WifiOff className="w-10 h-10" />,
      description: t('infrastructure.communication.description'),
      category: t('infrastructure.communication.category')
    },
    {
      name: t('infrastructure.mobile.title'),
      icon: <Database className="w-10 h-10" />,
      description: t('infrastructure.mobile.description'),
      category: t('infrastructure.mobile.category')
    },
    {
      name: t('infrastructure.onpremise.title'),
      icon: <Server className="w-10 h-10" />,
      description: t('infrastructure.onpremise.description'),
      category: t('infrastructure.onpremise.category')
    },
    {
      name: t('infrastructure.ai.title'),
      icon: <Brain className="w-10 h-10" />,
      description: t('infrastructure.ai.description'),
      category: t('infrastructure.ai.category')
    }
  ];


  return (
    <section id="technology" className="technology">
      <div className="container">
        <div className="section-header">
          <h2>{t('infrastructure.title')}</h2>
          <p>
            {t('infrastructure.description')}
          </p>
        </div>

        <div className="tech-grid">
          {infrastructure.map((infra, index) => (
            <div key={index} className="tech-card">
              <div className="tech-icon">
                {infra.icon}
              </div>
              <h3>{infra.name}</h3>
              <p>{infra.description}</p>
              <span className="tech-category">{infra.category}</span>
            </div>
          ))}
        </div>


        <div className="security-section">
          <h3>{t('infrastructure.capabilities.title')}</h3>
          <div className="security-badges">
            <div className="security-badge">
              <Shield className="security-icon" />
              <span>{t('infrastructure.capabilities.security')}</span>
            </div>
            <div className="security-badge">
              <Shield className="security-icon" />
              <span>{t('infrastructure.capabilities.assets')}</span>
            </div>
            <div className="security-badge">
              <Shield className="security-icon" />
              <span>{t('infrastructure.capabilities.decisions')}</span>
            </div>
            <div className="security-badge">
              <Shield className="security-icon" />
              <span>{t('infrastructure.capabilities.integration')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;